import { Box, Drawer, IconButton, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import styled from "@emotion/styled";

const StyledDrawer = styled(Drawer)(({ theme, width }) => ({
    '& .MuiDrawer-paper': {
        width: width,
        [theme.breakpoints.down('md')]: {
            width: "100%",
        },
    }
}))

export default function SideDrawer({ open, setOpen, drawerWidth, title, children, subtitle, icon }) {
    return (
        <StyledDrawer
            anchor='right'
            open={open}
            onClose={() => setOpen(false)}
            width={drawerWidth || '60%'}
        >
            {icon ? (
                // Opt-in polished header (icon badge + title + subtitle on one cohesive ground).
                // Only callers that pass `icon` get this; every existing caller keeps the header below.
                <Box sx={{
                    px: '30px', py: '16px', display: 'flex', alignItems: 'center', gap: 1.5,
                    backgroundColor: '#F7F8FA', borderBottom: '1px solid #E7EAF0',
                }} width={1}>
                    <Box sx={{
                        width: 42, height: 42, borderRadius: '12px', flex: '0 0 auto', display: 'grid', placeItems: 'center',
                        color: '#fff', backgroundImage: 'linear-gradient(135deg,#4F7DF0,#2065D1)', boxShadow: '0 6px 14px rgba(32,101,209,.32)',
                    }}>{icon}</Box>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography variant="h6" sx={{ fontWeight: 800, color: '#212B36', lineHeight: 1.2 }}>{title}</Typography>
                        {subtitle && <Typography variant='subtitle2' sx={{ color: '#637381', fontWeight: 500 }}>{subtitle}</Typography>}
                    </Box>
                    <Box sx={{ ml: 'auto' }}><IconButton onClick={() => setOpen(false)}><CloseIcon /></IconButton></Box>
                </Box>
            ) : (
                <>
                    <Box sx={{
                        px: '30px',
                        py: '10px',
                        color: 'black',
                        backgroundColor: '#f8f9fa',
                    }} width={1} display="flex" alignItems="center" justifyContent="space-between">
                        <Box><Typography variant="h6">{title}</Typography></Box>
                        <Box><IconButton onClick={() => setOpen(false)} ><CloseIcon /></IconButton></Box>
                    </Box>
                    <Box sx={{
                        px: '30px',
                    }}><Typography variant='subtitle2'>{subtitle}</Typography></Box>
                </>
            )}
            <Box
                width={1}
                sx={{
                    marginTop: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    marginBottom: 2,
                    px: '30px',
                    py: '10px'
                }}>
                {children}
            </Box>
        </StyledDrawer>
    )
}